<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">ยอดคงเหลือของแต่ละสาขา</h1>
                    <p class="text-white pb-3 px-3">ดูรายงานยอดคงเหลือทั้งหมดของแต่ละสาขา</p>
                </div>
                <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-12">
                                    <b-form-group id="input-group-1" label="ค้นหาวันที่ทำรายการ (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                        <div class="row align-self-center">
                                            <div class="col-lg-4">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                                <!-- :max-span="{days: 31}" -->
                                            </div>
                                            <div class="col-lg-3">
                                                <v-select
                                                    :options="listAgent"
                                                    label="name"
                                                    placeholder="เลือกตัวแทนที่ต้องการค้นหา"
                                                    v-model="agentId"
                                                    :reduce="agent => agent.agent_id"
                                                    taggable
                                                >
                                                    <template v-slot:option="option">
                                                        <span>{{ option.dealer_id }} ( {{option.name}} )</span>
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-lg-3">
                                                <v-select
                                                    :options="listShop"
                                                    label="name"
                                                    placeholder="เลือกสาขาที่ต้องการค้นหา"
                                                    v-model="shopId"
                                                    :reduce="shop => shop.wallet_account_shop.account_id"
                                                    taggable
                                                >
                                                    <template v-slot:option="option">
                                                        <span>{{ option.shop_code }} ( {{option.name}} )</span>
                                                    </template>
                                                </v-select>
                                            </div>
                                            <div class="col-lg-2">
                                                <button class="btn btn-info btn-sm-res" @click="funcHistoryTopBalanceWallet()">
                                                    <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <b-form-group label="ตัวกรอง" label-for="input-1" class="mb-0 pb-2">
                                        <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-8 col-md-6 d-flex justify-content-end">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel
                                                :columns="fields('excel')"
                                                :getData="getDataBalanceExportExcel"
                                                name="สรุปการใช้งาน wellet "
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint">
                            <b-table
                                show-empty
                                responsive
                                empty-text="ไม่มีรายละเอียดยอดคงเหลือของแต่ละสาขา"
                                empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                                :items="dataBalanceWallet"
                                :fields="fields()"
                                :filter="filter"
                                :busy="busy"
                                class="scroll-bar-pop"
                            >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                                <template slot="dealer_id" slot-scope="row">
                                    {{( row.item.dealer_id ) ? row.item.dealer_id : '-'}}
                                </template>
                                <template slot="shop_code" slot-scope="row">
                                    {{( row.item.shop_code ) ? row.item.shop_code : '-'}}
                                </template>
                                <template slot="top_balance" slot-scope="row">
                                    {{( row.item.hasOwnProperty('top_balance') ) ? row.item.top_balance  : 0 | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_sum_deposit" slot-scope="row">
                                    {{( row.item.hasOwnProperty('range_sum_deposit') ) ? row.item.range_sum_deposit  : 0 | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_sum_withdraw" slot-scope="row">
                                    {{( row.item.hasOwnProperty('range_sum_withdraw') ) ? row.item.range_sum_withdraw  : 0 | numFormat('0,0.00') }}
                                </template>
                                <template slot="balance" slot-scope="row">
                                    {{row.item.balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="peg_balance" slot-scope="row">
                                    {{row.item.peg_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="available_balance" slot-scope="row">
                                    {{row.item.available_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_latest_balance" slot-scope="row">
                                    {{row.item.range_latest_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_latest_peg_balance" slot-scope="row">
                                    {{row.item.range_latest_peg_balance | numFormat('0,0.00') }}
                                </template>
                                <template slot="range_latest_available_balance" slot-scope="row">
                                    {{row.item.range_latest_available_balance | numFormat('0,0.00') }}
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPpage"
                                    :value="pagination.currentPage"
                                    @input="changePage"
                                    align="right" >
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { getListShop } from "@/axios/shop.js";
import { getListAgent } from "@/axios/agent.js";

export default {
    name: "historytopbalance",
    components:{
        ExportExcel
    },
    data() {
        return {
            busy: true,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            switchRoute: false,
            filters: {
                excelDate: "",
                startDate: moment().format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD"),
            },
            agentId: null,
            shopId: null,
            listShop: [],
            listAgent: [],
            filter: null,
            filterAgent: null,
            dataBalanceWallet:[],
            pagination:{
                currentPage: 1,
                perPage: 20,
                totalPage: 1,
                totalItem: 0
            },

            funcHistoryTopBalanceWallet: null
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
        },
    },
    mounted() {
        this.assignFuncsByThemeName();

        getListShop().then( shop => {
            this.listShop = [ {wallet_account_shop:{account_id: false} , name: 'ดูทั้งหมด'} , ...shop.filter( data => data.wallet_open == true )];
        })
        getListAgent().then( agent => {
            this.listAgent = [ {agent_id: false , name: 'ดูทั้งหมด'} , ...agent.filter( data => data.wallet_open == true )];
        })

        this.funcHistoryTopBalanceWallet()
    },
    methods: {
        logEvent( event , date ){
            if( event == 'startSelection' ){
                this.minDate = moment(date, 'YYYY-MM-DD').add(-1, 'months').format("YYYY-MM-DD")
                this.maxDate =  moment(date, 'YYYY-MM-DD').add(1, 'months').format("YYYY-MM-DD")
                if( moment(date, 'YYYY-MM-DD').add(1, 'months').valueOf() > moment().valueOf() ){
                    this.maxDate = moment().format("YYYY-MM-DD");
                }
            }else if( event == 'finishSelection' ){
                this.minDate = null
                this.maxDate = moment().format("YYYY-MM-DD");
            }
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            const page = this.pagination.currentPage = i
            this.historyTopBalanceWalletAPI( page )
        },

        async historyTopBalanceWalletAPI( page = 1 ){
            this.busy = true

            let dateStart = moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss");
            let dateEnd = moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss");

            if (
                moment(this.filters.startDate).startOf('day').valueOf() == moment().startOf('day').valueOf() ||
                moment(this.filters.endDate).startOf('day').valueOf() == moment().startOf('day').valueOf()
            ) {
                this.switchRoute = true;
            } else {
                this.switchRoute = false;
            }

            let url =  this.switchRoute
            ? "/wallet/admin/wallet/info"
            : "/wallet/report/topBalanceSummary";

            await this.$http.get(
                    this.$API_URL + url,{
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            date_start: dateStart,
                            date_end: dateEnd,
                            ...( this.agentId ) ? { agent_id: this.agentId } : {},
                            ...( this.shopId ) ? { account_id: this.shopId } : {},
                            page: page
                        }
                    }
                )
                .then(res => {
                    let _data = res.data.data
                    this.dataBalanceWallet = _data.data
                    this.pagination.totalPage = _data.total_page
                    this.pagination.perPage = _data.per_page
                    this.pagination.totalItem = _data.total_item
                    this.pagination.currentPage = _data.page
                })
                .catch(() => {
                    this.dataBalanceWallet = [];
                })
                .finally(() => {
                    this.busy = false;
                });
        },
        async historyTopBalanceWalletV2API(page = 1) {
            this.busy = true

            // const start_date = moment(this.filters.startDate)
            //     .startOf('day')
            //     .subtract(7, 'hours')
            //     .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
            // const end_date = moment(this.filters.endDate)
            //     .endOf('day')
            //     .subtract(7, 'hours')
            //     .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

            this.$http.get(this.$API_URL + "/super_admin/wallet_v2/agent/wallet/paginate", {
                headers: {
                    Token: localStorage.getItem("access_token")
                },
                params: {
                        // start_date: start_date,
                        // end_date: end_date,
                        // ...( this.agentId ) ? { agent_id: this.agentId } : {},
                        // ...( this.shopId ) ? { account_id: this.shopId } : {},
                    page      : page,
                    limit     : this.pagination.perPage,
                    account_id: this.shopId
                }
            })
                .then(res => {
                    const res_data = res.data.data;

                    const res_data_items = [...res_data.items];
                    for (const [index, item] of res_data_items.entries()) {
                        // res_data_items[index]['transaction_id']     = item['id'];
                        // res_data_items[index]['credit']             = item['value'];
                        // res_data_items[index]['status']             = item['is_settled'] ? 1 : 0;
                        // res_data_items[index]['accumulated_credit'] = item['balance'];
                        // res_data_items[index]['available_credit']   = item['available_balance'];
                        // res_data_items[index]['ref_no2']            = item['remark'];
                    }

                    this.dataBalanceWallet = res_data_items

                    this.pagination.totalPage   = res_data.total_page
                    this.pagination.perPage     = res_data.per_page
                    this.pagination.totalItem   = res_data.total_item
                    this.pagination.currentPage = res_data.page
                })
                .catch(() => {
                    this.dataBalanceWallet = [];
                })
                .finally(() => {
                    this.busy = false;
                });
        },

        async getDataBalanceExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                let url = this.switchRoute
                ? "/wallet/admin/wallet/info"
                : "/wallet/report/topBalanceSummary";
                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + url,{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    date_start: moment(this.filters.startDate).startOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    date_end: moment(this.filters.endDate).endOf('day').format("YYYY-MM-DD HH:mm:ss"),
                                    ...( this.agentId ) ? { agent_id: this.agentId } : {},
                                    ...( this.shopId ) ? { account_id: this.shopId } : {},
                                    page: page++
                                }
                            }
                        )
                    )
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data.data)
                    })
                    resolve(dataExcel)
                })
            })
        },

        fields(type = null){
            let fields = [
                { key: "index", field: "index", label: "ลำดับ", sortable: true },
                { key: "dealer_id", field: "dealer_id", label: "รหัสตัวแทน", sortable: true , class:"text-center",
                    dataFormat: value => {
                        return (value) ? value : '-';
                    }
                },
                { key: "shop_code", field: "shop_code", label: "รหัสร้านค้า", sortable: true , class:"text-center",
                    dataFormat: value => {
                        return (value) ? value : '-';
                    }
                },
                { key: "top_balance", field: "top_balance", label: "ยอดยกมา", sortable: true , class:"text-center",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                { key: "range_sum_deposit", field: "range_sum_deposit", label: "ยอดเติมเครดิต", sortable: true , class:"text-center",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                { key: "range_sum_withdraw", field: "range_sum_withdraw", label: "รวมเครดิตที่ถูกใช้งาน", sortable: true , class:"text-center",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                ...(  this.switchRoute ) ? [
                    { key: "peg_balance", field: "peg_balance", label: "เครดิตที่รอดำเนินการ", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                    { key: "available_balance", field: "available_balance", label: "ยอดเครดิตที่ใช้ได้ (บาท)", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                    { key: "balance", field: "balance", label: "ยอดเครดิตคงเหลือ (บาท)", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                ] : [
                    { key: "range_latest_peg_balance", field: "range_latest_peg_balance", label: "เครดิตที่รอดำเนินการ", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                    { key: "range_latest_available_balance", field: "range_latest_available_balance", label: "ยอดเครดิตปัจจุบัน (บาท)", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                    { key: "range_latest_balance", field: "range_latest_balance", label: "ยอดเครดิตคงเหลือ (บาท)", sortable: true , class:"text-center",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        }
                    },
                ],

            ]
            if( type === 'excel' ) fields.splice(0, 1)
            return fields
        },

        assignFuncsByThemeName() {
            if (this.main_use_walletV2) {
                this.funcHistoryTopBalanceWallet = this.historyTopBalanceWalletV2API;
            } else {
                this.funcHistoryTopBalanceWallet = this.historyTopBalanceWalletAPI;
            }
        }
    }
};
</script>
